import { render, staticRenderFns } from "./LupaKataSandi.vue?vue&type=template&id=ea5b815e&scoped=true&"
import script from "./LupaKataSandi.vue?vue&type=script&lang=js&"
export * from "./LupaKataSandi.vue?vue&type=script&lang=js&"
import style0 from "./LupaKataSandi.vue?vue&type=style&index=0&id=ea5b815e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5b815e",
  null
  
)

export default component.exports